import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "../styles/global.css";
import { WorkspaceError } from "../components/workspace-error";
import { AppProviders } from "./providers";
import { AppRouter } from "./router";

const root = document.getElementById("root");
if (!root) throw new Error("The application root is missing.");

// A data-router owns navigation so dirty catalogue forms can block links and
// browser Back with React Router's supported blocker API.
const router = createBrowserRouter([
  {
    path: "*",
    errorElement: <WorkspaceError />,
    element: (
      <AppProviders>
        <AppRouter />
      </AppProviders>
    ),
  },
]);

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
